var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw","height":"100vh","overflow":"hidden","position":"absolute","z-index":"9999"}},[_c('div',{staticClass:"view-box"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }